<div class="header-nav-wrap" [ngClass]="{'container': layoutType === 'horizontal'}">
    <ng-container *ngTemplateOutlet="layoutType === 'vertical' ? vertical : horizontal"></ng-container>
</div>

<ng-template #vertical>
    <div class="header-nav-left">
        <nav-toggle [isMobile]="isMobile"></nav-toggle>
    </div>
    <ng-container *ngTemplateOutlet="headerNavRight"></ng-container>
</ng-template>

<ng-template #horizontal>
    <div class="header-nav-left">
        <nav-toggle *ngIf="isMobile" [isMobile]="isMobile"></nav-toggle>
        <logo *ngIf="!isMobile" [white]="logoColor !== 'dark'"></logo>
    </div>
    <ng-container *ngTemplateOutlet="headerNavRight"></ng-container>
</ng-template>

<ng-template #headerNavRight>
    <div class="header-nav-right">

      <div class="dropdown notification-dropdown pt-3" style="margin-right:6px;">
      <button class="btn btn-outline-primary btn-sm" (click)="refreshPage()">Refresh</button>
      </div>


              <!-- Container to hold both notifications -->
              <div class="d-flex flex-column align-items-start mt-4 ml-6">
                <!-- Notification for Pending Orders -->
                <div *ngIf="pendingNotificationMessage" class="alert alert-info text-dark p-2 mb-2 w-100">
                  <span [innerHTML]="pendingNotificationMessage"></span>
                </div>
              
                <!-- Notification for Confirmed Orders -->
                <div *ngIf="confirmedNotificationMessage" class="alert alert-success text-dark p-2 mb-2 w-100">
                  <span [innerHTML]="confirmedNotificationMessage"></span>
                </div>
              </div>
  

              <div class="dropdown notification-dropdown pt-3 mr-5" (click)="toggleDropdown($event)" [class.show]="dropdownOpen">
                <button class="btn btn-link dropdown-toggle position-relative" type="button">
                  Notifications
                  <i class="feather icon-bell"></i>
              
                  <!-- Notification alert icon -->
                  <span *ngIf="pendingCount > 0 || confirmedCount > 0"
                        class="position-absolute  start-100 translate-middle badge rounded-circle bg-danger text-white"
                        style="font-size: 0.6rem; width: 18px; height: 18px; display: flex; align-items: center;
                         justify-content: center; margin-top: 7px;margin-left: -53px">
                    !
                  </span>
                </button>
              
                <ul class="dropdown-menu dropdown-menu-end" [class.show]="dropdownOpen">
                  <li class="dropdown-header">
                    <i class="feather icon-list mr-2"></i>Details
                  </li>
                  <li class="dropdown-item">
                    <a routerLinkActive="router-link-active" routerLink="/orderList">
                      <span class="nav-menu-item-title">
                        <i class="feather icon-align-right"></i>
                        Pending Order List
                        <button type="button" class="btn btn-danger btn-sm rounded-circle">
                          <span class="badge-circle">{{ pendingCount }}</span>
                        </button>
                      </span>
                    </a>
                  </li>
                  <li class="dropdown-item">
                    <a routerLinkActive="router-link-active" routerLink="/jssCreation">
                      <span class="nav-menu-item-title">
                        <i class="feather icon-file ng-star-inserted"></i>
                        Pending JSS
                        <button type="button" class="btn btn-danger btn-sm rounded-circle">
                          <span class="badge-circle">{{ confirmedCount }}</span>
                        </button>
                      </span>
                    </a>
                  </li>
                  <li class="dropdown-item text-primary">
                    <i class="feather icon-eye mr-2"></i> Close All
                  </li>
                </ul>
              </div>
              

          

        <dropdown dropdownClass="header-nav-item-select nav-profile" (click)="navProfile.toggle($event)">
            <div class="toggle-wrapper d-flex align-items-center pt-3">
                <img src="{{profileimg}}" alt="profile-user" class="rounded-circle me-2 thumb-sm" style="width: 40px;" />
                <span class="fw-bold mx-1">{{username}}</span>
                <i class="feather icon-chevron-down"></i>
            </div>
            <dropdown-menu #navProfile alignment="right">
                
                <div class="nav-profile-header">
                    <div class="d-flex align-items-center">
                        <!-- <avatar src="/assets/images/avatars/thumb-1.jpg"></avatar> -->
                        <div class="d-flex flex-column ms-1">
                            <span class="fw-bold text-dark">{{username}}</span>
                            <span class="font-size-sm">{{email}}</span>
                        </div>
                    </div>
                </div>
                <a class="dropdown-item dropdown-menu-item" routerLink="/UserProfile"><i class="feather icon-user font-16 me-1 align-text-bottom"></i> Profile</a>
                    <div class="dropdown-divider mb-0"></div>
                    <a class="dropdown-item dropdown-menu-item" (click)="logOut()"><i class="feather icon-power font-16 me-1 align-text-bottom"></i> Sign Out</a>
                    <div class="dropdown-divider mb-0"></div>

            </dropdown-menu>
        </dropdown>
    </div>
</ng-template>